module.exports = __webpack_public_path__ + "fonts/montserrat-italic-webfont.3cc9beb.woff2";